module.exports = __webpack_public_path__ + "images/icon/checkbox_selected_disable-541744f0.svg";